export const b1Words = [
  {
    word: "achieve",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ3c2NjAwYTR0MzJyaGcwNThoMzIwZTBmbms3MGtrZ3NxY215eTFybCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/gHtd1OG1w8Z9XPV0EZ/giphy.gif",
    synonyms: ["accomplish", "attain", "reach"],
    example: "She worked hard to achieve her goals.",
    definition: "To successfully complete something or get a good result, especially by effort."
  },
  {
    word: "advice",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExa2txOGtjeGJqcWx1dGt2bTcyejBnaTFjbm5jaWNoa2YwcjUyMDJ2cCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/1hMdWxlfKh13NOMRvP/giphy.gif",
    synonyms: ["guidance", "recommendation", "suggestion"],
    example: "My teacher gave me good advice about studying.",
    definition: "An opinion or suggestion about what someone should do."
  },
  {
    word: "arrange",
    image: "https://plus.unsplash.com/premium_photo-1726704065178-fc709a5f104b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["organize", "plan", "schedule"],
    example: "I will arrange a meeting for next week.",
    definition: "To plan or organize something in advance."
  },
  {
    word: "behave",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExOXlqemEzd2s5MXY2eGNqcTRlOGszOGt3bWNkb2I2ZXIwMjlvbmVyZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/njDLp512JEZKNK6JHg/giphy.gif",
    synonyms: ["act", "conduct", "perform"],
    example: "Please behave yourself at the party.",
    definition: "To act in a particular way, especially to be polite or correct."
  },
  {
    word: "career",
    image: "https://i.pinimg.com/736x/f8/a3/a4/f8a3a4d3f08542aec871a09625ff9d9c.jpg",
    synonyms: ["profession", "occupation", "job"],
    example: "She is planning a career in medicine.",
    definition: "A job or profession that someone does for a long time."
  },
  {
    word: "combine",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExdnEyaWlqNHBmM3gyNXZ0aGp0MXk4eGFtbmdvcXhudHF6bm1xbWo0cCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/idv3kRilTGWT2tfUxe/giphy.gif",
    synonyms: ["merge", "blend", "mix"],
    example: "You should combine work with pleasure.",
    definition: "To join or bring together different things."
  },
  {
    word: "compare",
    image: "https://images.unsplash.com/photo-1464374288807-174911d4adb9?q=80&w=1980&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["contrast", "match", "evaluate"],
    example: "Compare the two pictures and find the differences.",
    definition: "To look at how things are similar or different."
  },
  {
    word: "depend",
    image: "https://i.pinimg.com/736x/28/52/bf/2852bf697ee7c3b682134832d2668b77.jpg",
    synonyms: ["rely", "trust", "count on"],
    example: "You can always depend on your friends.",
    definition: "To trust or rely on someone or something."
  },
  {
    word: "effort",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExNGM1NGJ6djFnNnB5OWJmYnQ3Z3ZkcGphcG0zdWQxamZ3eDluamMydyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/zIOdLMZDcBDc2gk6vV/giphy.gif",
    synonyms: ["attempt", "struggle", "try"],
    example: "She made a great effort to improve her English.",
    definition: "An attempt to do something that needs a lot of energy."
  },
  {
    word: "environment",
    image: "https://i.pinimg.com/736x/5f/68/3e/5f683eb26c1a4d464278e70ba81d92d3.jpg",
    synonyms: ["surroundings", "habitat", "ecosystem"],
    example: "We need to protect the environment.",
    definition: "The natural world, including land, water, air, and living things."
  },
  {
    word: "feature",
    image: "https://i.pinimg.com/736x/83/38/41/8338412126476ad24a6713b291c1c574.jpg",
    synonyms: ["characteristic", "trait", "aspect"],
    example: "This phone has many new features.",
    definition: "An important or interesting part of something."
  },
  {
    word: "goal",
    image: "https://i.pinimg.com/736x/2f/ab/ad/2fabadb275a5878ad996f7746e086b2a.jpg",
    synonyms: ["aim", "target", "objective"],
    example: "His goal is to become a doctor.",
    definition: "Something you want to achieve in the future."
  },
  {
    word: "improve",
    image: "https://i.pinimg.com/736x/8b/ee/f1/8beef1a7494f0a05918df8ce3e6d8c7a.jpg",
    synonyms: ["enhance", "develop", "boost"],
    example: "She took a course to improve her writing skills.",
    definition: "To make something better."
  },
  {
    word: "limit",
    image: "https://media.istockphoto.com/id/463491401/photo/speed-limit-on-german-autobahn.jpg?s=2048x2048&w=is&k=20&c=v38eNely_8kcQKYSZ7v3OyY90BpiR-xtEgc2J3FACN8=",
    synonyms: ["boundary", "restriction", "maximum"],
    example: "There's a limit to how much you can spend.",
    definition: "The greatest or smallest amount allowed."
  },
  {
    word: "mention",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZTVlY2E5aGttaHQ2aTM0MjIwYWtxN25mOWk3MWw5eHhjcWxxMzdmMyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/QT2pP4camMCWWH1vUU/giphy.gif",
    synonyms: ["refer to", "bring up", "state"],
    example: "He didn’t mention the problem to anyone.",
    definition: "To speak or write about something briefly."
  },
  {
    word: "notice",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExYmkyOGM1Zm1ibXIyYjYzbTY3bmRuYzZ1YTl3cngwYXd5bmpjcnR3NiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/iGtlFzmLReCn5qBJlY/giphy.gif",
    synonyms: ["observe", "see", "detect"],
    example: "Did you notice that she changed her hair?",
    definition: "To see or become aware of something."
  },
  {
    word: "prefer",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExNXhrbHdwbTU1M2oycjU5NG1neGFzeTN6cTcwMjJweHl1d2Zna3hodyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/nFibir901ajnEKbh4d/giphy.gif",
    synonyms: ["choose", "favor", "opt for"],
    example: "I prefer tea over coffee.",
    definition: "To like one thing more than another."
  },
  {
    word: "receive",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZHBjMG5lOGdxYzB0ZDQzYnp4Z2h5czk4NGoyNWQ4YWwwbWw2YWx6OSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o7TKvNlunS6UNxZiE/giphy.gif",
    synonyms: ["get", "accept", "collect"],
    example: "I received a gift for my birthday.",
    definition: "To get something that is given or sent."
  },
  {
    word: "require",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExYXhtZDRoenN2bWJxNno2ZjBubGVlYXplczU2MTdibmhmYjZjNTJpMiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/LSipW1bwdEJVCkWNG0/giphy.gif",
    synonyms: ["need", "demand", "call for"],
    example: "The job requires experience in sales.",
    definition: "To need something for a particular purpose."
  },
  {
    word: "share",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExc3ZwYm1lMW1qMGV2b3MzZXdsajdoNXB5Mm11dTIwZDMxMWF0cDRtbiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/udnbNDZcs1skROk6Wa/giphy.gif",
    synonyms: ["give", "distribute", "divide"],
    example: "They shared their food with the poor.",
    definition: "To have or use something with others."
  },
  {
    word: "suggest",
    image: "https://plus.unsplash.com/premium_photo-1681995720709-3ef602255caf?q=80&w=1122&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["recommend", "propose", "advise"],
    example: "She suggested going for a walk.",
    definition: "To give an idea or plan for someone to consider."
  },
  {
    word: "trust",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExa2pycHRhcXVtYWZ3eDY0YWhudzZsc2Z6aWV2MjN1Z2Rmb2lqYmhsdiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/TTarU6pCtJfZm/giphy.gif",
    synonyms: ["believe", "rely on", "have faith in"],
    example: "I trust my best friend completely.",
    definition: "To believe that someone is honest or reliable."
  },
  {
    word: "valuable",
    image: "https://i.pinimg.com/736x/5e/f5/16/5ef5169b7f04bc0a5f788177337ca35d.jpg",
    synonyms: ["precious", "important", "worthwhile"],
    example: "This ring is very valuable.",
    definition: "Worth a lot of money or important in some way."
  },
  {
    word: "waste",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExcm5mYmthcGNzdTU1aHduMzB6ZW11Z3o3azM2YTV4ODViZXh6c21ybCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/mA1Q2zJDyr7nk62lrO/giphy.gif",
    synonyms: ["squander", "misuse", "throw away"],
    example: "Don’t waste your time on that.",
    definition: "To use something carelessly or without purpose."
  },
  {
    word: "wonder",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExaTl3MDNyeHBjeXg0MHJ6b3lvbndiZ2tsZ3pkY2hmNjA3ZHhjcmV6eiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3oFzmerJ9kykSR92jm/giphy.gif",
    synonyms: ["think", "ask oneself", "ponder"],
    example: "I wonder what he’s doing now.",
    definition: "To think about something and want to know more about it."
  }
];
